import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Spinner({ className, label = "Loading" }) {
    return (_jsx("span", { role: "status", "aria-label": label, className: cn("inline-block size-5 animate-spin rounded-full border-2 border-current border-t-transparent", className) }));
}
//# sourceMappingURL=Spinner.js.map